import React, { Suspense, useMemo, useEffect, useState } from 'react';
import Core from 'containers/base/Core';
import { Route, Switch, Redirect, useHistory, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalAppStyle from 'styles/base';
import {
  Error,
  Home,
  Auth,
  About,
  Test,
  User,
  Dashboard,
  Project,
  Store,
  Account,
  Partner,
  Support,
  Invoice,
  Notifications,
  Payment,
  CodeRegistration,
  Kpi,
  Patient,
  Util,
  Recording,
} from 'pages';
// import FullScreenLoading from 'components/base/loading/FullScreenLoading';
import AppErrorBoundary from 'components/base/error/AppErrorBoundary';
import LRoute from 'components/base/route/LRoute';
import PrivateRoute from 'components/base/route/PrivateRoute';
import './App.scss';
import { pageUrl } from 'lib/mapper';
import { useContext } from 'react';
import { AppContext } from 'contexts/AppContext';
import { useShallowAppSelector } from 'store/hooks';
import { isLogInSelector, signOut } from 'store/modules/auth';
import QuickStart from 'pages/quickstart/QuickStart';
import { AppActions } from 'store/actionCreators';
import { oemState, oemStatus } from 'lib/store';

function App() {
  const { theme } = useContext(AppContext);
  const { isLogIn } = useShallowAppSelector(state => ({
    isLogIn: isLogInSelector(state),
  }));
  const { ipcRenderer } = window;
  const history = useHistory();
  const { oemInfo } = useShallowAppSelector(state => ({
    oemInfo: state.app.oemInfo,
  }));

  useEffect(() => {
    if (ipcRenderer) {
      ipcRenderer.on('logoutClick', (event: any, payload: any) => {
        // // 로그아웃 처리
        // signOut();
        history.push(pageUrl.auth.signOut);
      });
    }
  }, []);

  useEffect(() => {
    if (ipcRenderer) {
      handleOemInfo();
    }
  }, []);

  const handleOemInfo = async () => {
    AppActions.set_oem_info(await ipcRenderer.invoke('getOEMInfo'));
  };

  // 하드웨어 가속 확인
  useEffect(() => {
    const checkHardwareAcceleration = () => {
      console.log('=== WebGL 하드웨어 가속 정보 ===');
      const canvas = document.createElement('canvas');
      const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

      if (gl && gl instanceof WebGLRenderingContext) {
        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        if (debugInfo) {
          const vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
          const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);

          const isHardwareAccelerated =
            !renderer.toLowerCase().includes('swiftshader') &&
            !renderer.toLowerCase().includes('llvmpipe') &&
            !renderer.toLowerCase().includes('software');

          console.log('하드웨어 가속 활성화:', isHardwareAccelerated);
          console.log('GPU 벤더:', vendor);
          console.log('GPU 렌더러:', renderer);
          console.log('================================');
        } else {
          console.log('WebGL 디버그 정보를 가져올 수 없습니다.');
        }
      } else {
        console.error('WebGL을 지원하지 않습니다.');
      }
    };

    checkHardwareAcceleration();
  }, []);

  return (
    <ThemeProvider theme={{ ...theme, $oem: oemInfo?.oem ?? 'sync' }}>
      <GlobalAppStyle />
      <AppErrorBoundary>
        {/* <Suspense fallback={<h1>loading...</h1>}> */}
        <Switch>
          {/* <Redirect exact path={pageUrl.index} to={pageUrl.home} />
          <Route path={pageUrl.home}>{isLogIn ? <Dashboard /> : <CodeRegistration />}</Route> */}
          <Redirect exact path={pageUrl.index} to={pageUrl.home} />
          <Route path={pageUrl.home} component={CodeRegistration} />
          <PrivateRoute path={pageUrl.dashboard.index} component={Dashboard} />
          <PrivateRoute path={pageUrl.quickstart.index} component={QuickStart} />

          {/* <Route path={pageUrl.home} component={CodeRegistration} /> */}
          <LRoute path={pageUrl.auth.index} component={Auth} />
          <Route path={pageUrl.error.index} component={Error} />
          <PrivateRoute path={pageUrl.user.index} component={User} />
          {/* <PrivateRoute path={pageUrl.dashboard.index} component={Dashboard} /> */}
          <PrivateRoute path={pageUrl.project.index} component={Project} />
          <PrivateRoute path={pageUrl.patient.index} component={Patient} />
          <PrivateRoute path={pageUrl.store.index} component={Store} />
          <PrivateRoute path={pageUrl.account.index} component={Account} />
          <PrivateRoute path={pageUrl.partner.index} component={Partner} />
          <PrivateRoute path={pageUrl.support.index} component={Support} />
          <PrivateRoute path={pageUrl.invoice.index} component={Invoice} />
          <PrivateRoute path={pageUrl.notifications.index} component={Notifications} />
          <PrivateRoute path={pageUrl.kpi.index} component={Kpi} />
          <Route path={pageUrl.payment.index} component={Payment} />
          <Route path={pageUrl.Util.index} component={Util} />
          <Route path={pageUrl.recording.index} component={Recording} />
          {/* <PrivateRoute path="/about" component={About} /> */}
          {/* <Route path="/about" component={About} /> */}
          {/* <Route path="/test" component={Test} /> */}
          <Route component={() => <Redirect to="/error/404" />} />
        </Switch>
        {/* </Suspense> */}

        <Core />
      </AppErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
